import { render, staticRenderFns } from "./Office.vue?vue&type=template&id=463e23e0&scoped=true"
import script from "./Office.vue?vue&type=script&lang=js"
export * from "./Office.vue?vue&type=script&lang=js"
import style0 from "./Office.vue?vue&type=style&index=0&id=463e23e0&prod&lang=scss&scoped=true"
import style1 from "./Office.vue?vue&type=style&index=1&id=463e23e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463e23e0",
  null
  
)

export default component.exports